<div class="toolbar" role="banner">
  <div class="toolbar-service">
    <img alt="Onkopus Logo" src="./assets/images/DrugOn_Logo.svg"/>
    <span>DrugOn</span>
  </div>
  <div class="toolbar-menu">
    <a class="toolbar-menu-item" routerLink="/home">Home</a>
    <a class="toolbar-menu-item" routerLink="/classification">Classification</a>
    <a class="toolbar-menu-item" routerLink="/viewer">Viewer</a>
    <a class="toolbar-menu-item" routerLink="/about">About</a>
  </div>
</div>

<div class="content" role="main">
  <router-outlet></router-outlet>
</div>